<div class="user-edit-wrapper">
  @if (!companyConfiguration() || isLoadingUser()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych użytkownika..." />
    </div>
  } @else {
    <div class="page-header">
      <div class="page-header-icon">
        <span nz-icon nzType="edit" nzTheme="outline"></span>
      </div>
      <div>
        <h2 class="page-header-title">Edycja użytkownika</h2>
        <p class="page-header-subtitle">Zmień dane konta i zapisz aktualizację</p>
      </div>
    </div>

    <form nz-form nzLayout="vertical" class="edit-form">
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="lock" nzTheme="outline" class="section-icon"></span>
          <span>Dane logowania</span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label nzRequired>Login</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.login().invalid() &&
                  (loginForm.login().touched() || submitted() || loginForm.login().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-input-wrapper nzPrefixIcon="user">
                  <input
                    nz-input
                    placeholder="Wpisz login"
                    [value]="loginForm.login().value()"
                    disabled
                  />
                </nz-input-wrapper>
                <app-field-error
                  [control]="loginForm.login()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label nzRequired>Email</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.email().invalid() &&
                  (loginForm.email().touched() || submitted() || loginForm.email().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-input-wrapper nzPrefixIcon="mail">
                  <input
                    nz-input
                    type="email"
                    placeholder="adres@email.pl"
                    [formField]="loginForm.email"
                  />
                </nz-input-wrapper>
                <app-field-error
                  [control]="loginForm.email()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="idcard" nzTheme="outline" class="section-icon"></span>
          <span>Dane osobowe</span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Imię</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.firstName().invalid() &&
                  (loginForm.firstName().touched() || submitted() || loginForm.firstName().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input nz-input placeholder="Imię" [formField]="loginForm.firstName" />
                <app-field-error
                  [control]="loginForm.firstName()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Drugie imię</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.secondName().invalid() &&
                  (loginForm.secondName().touched() ||
                    submitted() ||
                    loginForm.secondName().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input nz-input placeholder="Opcjonalne" [formField]="loginForm.secondName" />
                <app-field-error
                  [control]="loginForm.secondName()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Nazwisko</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.lastName().invalid() &&
                  (loginForm.lastName().touched() || submitted() || loginForm.lastName().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input nz-input placeholder="Nazwisko" [formField]="loginForm.lastName" />
                <app-field-error
                  [control]="loginForm.lastName()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Telefon</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.phoneNumber().invalid() &&
                  (loginForm.phoneNumber().touched() ||
                    submitted() ||
                    loginForm.phoneNumber().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-input-wrapper>
                  <input
                    nz-input
                    placeholder="Numer telefonu"
                    [formField]="loginForm.phoneNumber"
                  />
                  <nz-select
                    [formField]="loginForm.phoneNumberCountryCode"
                    style="width: 90px"
                    nzInputAddonBefore
                  >
                    <nz-option nzValue="+48" nzLabel="+48 🇵🇱"></nz-option>
                  </nz-select>
                  <app-field-error
                    [control]="loginForm.phoneNumberCountryCode()"
                    [submitted]="submitted()"
                  ></app-field-error>
                </nz-input-wrapper>
                <app-field-error
                  [control]="loginForm.phoneNumber()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label nzRequired>Typ identyfikatora</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.identifierType().invalid() &&
                  (loginForm.identifierType().touched() ||
                    submitted() ||
                    loginForm.identifierType().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-select
                  [formField]="loginForm.identifierType"
                  nzPlaceHolder="Wybierz typ identyfikatora"
                >
                  @for (identifierType of identifierTypes(); track identifierType.name) {
                    <nz-option
                      [nzValue]="identifierType.name"
                      [nzLabel]="identifierType.description"
                    />
                  }
                </nz-select>
                <app-field-error
                  [control]="loginForm.identifierType()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Wartość identyfikatora</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.identifierValue().invalid() &&
                  (loginForm.identifierValue().touched() ||
                    submitted() ||
                    loginForm.identifierValue().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-input-wrapper nzCompact>
                  <input
                    nz-input
                    placeholder="Wartość identyfikatora"
                    [formField]="loginForm.identifierValue"
                  />
                </nz-input-wrapper>
                <app-field-error
                  [control]="loginForm.identifierValue()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="idcard" nzTheme="outline" class="section-icon"></span>
          <span>Dane medyczne</span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Numer licencji</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.licenseNumber().invalid() &&
                  (loginForm.licenseNumber().touched() ||
                    submitted() ||
                    loginForm.licenseNumber().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Numer licencji"
                  [formField]="loginForm.licenseNumber"
                />
                <app-field-error
                  [control]="loginForm.licenseNumber()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label>Tytuł medyczny</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.medTitle().invalid() &&
                  (loginForm.medTitle().touched() || submitted() || loginForm.medTitle().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-select [formField]="loginForm.medTitle" nzPlaceHolder="Wybierz tytuł medyczny">
                  @for (title of medTitles(); track title.name) {
                    <nz-option [nzValue]="title.name" [nzLabel]="title.description" />
                  }
                </nz-select>
                <app-field-error
                  [control]="loginForm.medTitle()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="7" [nzMd]="7">
            <nz-form-item>
              <nz-form-label>Specjalizacja medyczna</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  loginForm.medSpecialty().invalid() &&
                  (loginForm.medSpecialty().touched() ||
                    submitted() ||
                    loginForm.medSpecialty().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-input-wrapper>
                  <input
                    nz-input
                    placeholder="Specjalizacja medyczna"
                    [formField]="loginForm.medSpecialty"
                  />
                  <div nzInputAddonBefore>
                    <a nz-dropdown [nzDropdownMenu]="menu">
                      <nz-icon nzType="plus-circle" nzTheme="outline" />
                    </a>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <div class="dropdown-menu-picker">
                        <ul nz-menu>
                          @for (
                            medSpecialization of medSpecializations();
                            track medSpecialization.name
                          ) {
                            <li
                              nz-menu-item
                              (click)="setMedSpecialization(medSpecialization.description)"
                            >
                              {{ medSpecialization.description }}
                            </li>
                          }
                        </ul>
                      </div>
                    </nz-dropdown-menu>
                  </div>
                </nz-input-wrapper>
              </nz-form-control>
              <app-field-error
                [control]="loginForm.medSpecialty()"
                [submitted]="submitted()"
              ></app-field-error>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="safety-certificate" nzTheme="outline" class="section-icon"></span>
          <span>Uprawnienia</span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label nzRequired>Rola</nz-form-label>
              <nz-form-control>
                <nz-select [formField]="loginForm.roleId" nzPlaceHolder="Wybierz rolę">
                  @for (role of companyConfiguration()?.avilableRoles; track role.id) {
                    <nz-option [nzValue]="role.id" [nzLabel]="role.defaultName!" />
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label nzRequired>Domyślna placówka</nz-form-label>
              <nz-form-control>
                <nz-select
                  [formField]="loginForm.defaultUnitId"
                  nzPlaceHolder="Wybierz domyślną placówkę"
                >
                  @for (unit of companyConfiguration()!.structure.units; track unit.id) {
                    <nz-option [nzValue]="unit.id" [nzLabel]="unit.name!" />
                  }
                </nz-select>
                <app-field-error
                  [control]="loginForm.defaultUnitId()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
          <span>Placówki</span>
        </div>

        <div class="units-toolbar">
          <label
            nz-checkbox
            [nzChecked]="selectAllUnits()"
            (nzCheckedChange)="toggleSelectAllUnits()"
          >
            <strong>Zaznacz wszystkie</strong>
          </label>
          <nz-tag nzColor="processing">
            Wybrano: {{ loginForm.selecteUnitIds().value().length }} /
            {{ companyConfiguration()?.structure?.units?.length || 0 }}
          </nz-tag>
        </div>

        <nz-divider nzDashed style="margin: 12px 0"></nz-divider>

        <div nz-row [nzGutter]="[16, 8]">
          @for (unitRow of unitRows(); track unitRow) {
            @for (unit of unitRow; track unit.id) {
              <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
                <label
                  nz-checkbox
                  class="unit-checkbox"
                  [nzChecked]="loginForm.selecteUnitIds().value().includes(unit.id!)"
                  (nzCheckedChange)="unitCheckboxToggle(unit.id!, $event)"
                >
                  {{ unit.name }}
                </label>
              </div>
            }
          }
        </div>
        <app-field-error
          [control]="loginForm.selecteUnitIds()"
          [submitted]="submitted()"
        ></app-field-error>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
          <span>Moduły</span>
        </div>
        <div class="units-toolbar">
          <label
            nz-checkbox
            [nzChecked]="selectAllModules()"
            (nzCheckedChange)="toggleSelectAllModules()"
          >
            <strong>Zaznacz wszystkie</strong>
          </label>
          <nz-tag nzColor="processing">
            Wybrano: {{ loginForm.selectedModules().value().length }} /
            {{ companyConfiguration()?.avilableModules?.length || 0 }}
          </nz-tag>
        </div>
        <nz-divider nzDashed style="margin: 12px 0"></nz-divider>

        <div nz-row [nzGutter]="[16, 8]">
          @for (module of companyConfiguration()?.avilableModules; track module.id) {
            <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
              <label
                nz-checkbox
                class="unit-checkbox"
                [nzDisabled]="module.isRequired"
                [nzChecked]="
                  loginForm.selectedModules().value().includes(module.name!) || module.isRequired
                "
                (nzCheckedChange)="moduleCheckboxToggle(module.name!, $event)"
              >
                {{ module.readableName }}
              </label>
            </div>
          }
          <app-field-error
            [control]="loginForm.selectedModules()"
            [submitted]="submitted()"
          ></app-field-error>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
          <span>Dostęp do aplikacji</span>
        </div>
        <nz-divider nzDashed style="margin: 12px 0"></nz-divider>

        <div nz-row [nzGutter]="[16, 8]">
          @for (role of roles; track role.name) {
            <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
              <label
                nz-checkbox
                class="unit-checkbox"
                [nzChecked]="loginForm.selectedRoles().value().includes(role.name!)"
                (nzCheckedChange)="roleCheckboxToggle(role.name!, $event)"
              >
                {{ role.description }}
              </label>
            </div>
          }
          <app-field-error
            [control]="loginForm.selectedRoles()"
            [submitted]="submitted()"
          ></app-field-error>
        </div>
      </nz-card>
    </form>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" routerLink="/users">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>
      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [nzLoading]="isSubmitting()"
        [disabled]="isSubmitting() || (!loginForm().valid() && submitted())"
      >
        <span nz-icon nzType="edit"></span>
        Zapisz zmiany
      </button>
    </div>
    @if (!this.loginForm().valid()) {
      <span class="ant-form-item-explain-error form-error">Formularz zawiera błędy</span>
    }
  }
</div>
